import { makeVar } from '@apollo/client';

type TBlockCloseFn = (closeGlobalDrawer: () => void) => void;

export const blockGlobalDrawer = makeVar<TBlockCloseFn | null>(null);
